// link 枚举
export const Langs = [
  'en',
  'en-HK',
  'zh-MY',
  'zh-HK',
  'zh-TW',
  'ja-JP',
  'ru-RU',
  'es-ES',
  'vi-VN',
  'pt-BR',
  'th-TH',
  'id-ID',
  'fil-PH',
  'kk-KZ',
  'uk-UA',
  'pt-PT',
  'ar-SA',
  'es-MX',
  'es-AR',
  'es-419',
  'nl-NL',
  'en-NL',
  'pl-PL',
  'ro-RO',
  'en-IN',
  'en-NG',
];

// 不同语言，站点不同
// <link ref="alternate" href="https://www.{AlternateSite}/en" hrefLang ="en" />
export const AlternateSite = {
  default: 'bybit.com',
  'en-HK': 'byhkbit.com',
  'zh-MY': 'bybitglobal.com',
  'zh-HK': 'byhkbit.com',
  'zh-TW': 'bybit.com',
  'id-ID': 'bybitglobal.com',
  'nl-NL': 'bybit.nl',
  'en-NL': 'bybit.nl',
  'tr-TUR': 'bybit-tr.com',
  'en-TR': 'bybit-tr.com',
  'en-IN': 'bybitglobal.com',
  'en-NG': 'bybitglobal.com',
  'vi-VN': 'bybitglobal.com',
};

// bybit语言标识和谷歌搜索引擎收录的语言标识对应
// <link ref="alternate" href="https://www.bybit.com/en" hrefLang = {AlternateHrefLang} />
export const AlternateHrefLang = {
  'tr-TUR': 'tr-TR',
  'es-419': 'es',
  'fil-PH': 'tl',
};

// 未收录的语言 指向bybit语言
// <link ref="alternate" href="https://www.bybit.com/en" hrefLang="en-IN" />
export const AlternateLocaleUrl = {
  'en-IN': 'en',
  'en-NG': 'en',
};
